import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from '../../../internal/cx.js';
export function Card({ variant = 'outline', flush = false, className, ...rest }) {
    return (_jsx("div", { ...rest, className: cx('mn-card', className), "data-variant": variant, "data-flush": flush || undefined }));
}
export function CardHeader({ className, ...rest }) {
    return _jsx("div", { ...rest, className: cx('mn-card__header', className) });
}
export function CardTitle({ as: Tag = 'h3', className, ...rest }) {
    return _jsx(Tag, { ...rest, className: cx('mn-card__title', className) });
}
export function CardDescription({ className, ...rest }) {
    return _jsx("p", { ...rest, className: cx('mn-card__description', className) });
}
export function CardContent({ className, ...rest }) {
    return _jsx("div", { ...rest, className: cx('mn-card__content', className) });
}
export function CardFooter({ className, ...rest }) {
    return _jsx("div", { ...rest, className: cx('mn-card__footer', className) });
}
//# sourceMappingURL=card.js.map